import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { getSetting, setSetting } from '../../../../../utils/settings';

const ContinuousViewPlugin = ({ continuousView, setContinuousView }) => {
  const { t } = useTranslation();
  const settingKey = 'continuous-view-plugin/enabled';

  function handleToggleContinuousView() {
    const newValue = !continuousView;

    setSetting(settingKey, newValue);
    setContinuousView(newValue);
  }

  useLayoutEffect(() => {
    const continuousViewSetting = getSetting(settingKey);

    if (continuousViewSetting) setContinuousView(true);
  }, [setContinuousView]);

  return (
    <div className="song-plugin continuous-view-plugin">
      <span className="plugin__title">{t('view.continuous')}</span>
      <div className={`plugin__body ${continuousView ? 'on' : 'off'}`} onClick={handleToggleContinuousView}>
        <span className="plugin__toggle">{continuousView ? t('common.on') : t('common.off')}</span>
      </div>
    </div>
  );
};

ContinuousViewPlugin.propTypes = {
  continuousView: PropTypes.bool,
  setContinuousView: PropTypes.func,
};

export default ContinuousViewPlugin;
